import { render, staticRenderFns } from "./CustomerFieldAdd.vue?vue&type=template&id=4b1ab393"
import script from "./CustomerFieldAdd.vue?vue&type=script&lang=js"
export * from "./CustomerFieldAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports